import React, { forwardRef, HTMLAttributes } from "react";
import classNames from "classnames";

export type BodyProps = HTMLAttributes<HTMLDivElement>;

export const Body = forwardRef<HTMLDivElement, BodyProps>(({ className, children, ...rest }, ref) => {
  return (
    <div {...rest} ref={ref} className={classNames("ui-bottom-sheet-dialog-body", className)}>
      {children}
    </div>
  );
});

Body.displayName = "BottomSheet.Body";
